module.exports = __webpack_public_path__ + "img/Master-4.37b66f1a.png";